// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserSection_wrapper__2Zmii","p":"UserSection_p__1NWFj"};